<template>
    <div>
        <h1 class="title is-1">{{ $t('menu.documents') }}</h1>
        <b-table :data="documents ? documents : []">
            <template slot-scope="props">
                <b-table-column field="name" :label="$t('documents.name')">
                    <a :href="props.row.path" target="_blank">
                        {{props.row.name}}     
                    </a> 
                </b-table-column>
            </template>
        </b-table>
    </div>
</template>
<script>
    import axios from 'axios'

    export default {
        data(){
            return {
                documents: null,
            }
        },
        methods: {
            getData(){
                axios.get("documents.json")
                .then(response => {
                    this.isLoading = true
                    this.documents = response.data
                    this.isLoading = false
                })
            },
            getURLExtension( url ) {
                return url.split(/#|\?/)[0].split('.').pop().trim().toUpperCase()
            }
        },
        mounted(){
            this.getData()
        }
    }
</script>